module.exports = __webpack_public_path__ + "img/cell-grid-light-01.20d80d57.jpg";